;(function() {
  'use strict'

  controller.$inject = ["$scope", "websiteService"];
  angular.module('core.footer').controller('Footer', controller)

  /* @ngInject */
  function controller($scope, websiteService) {
    $scope.year = moment().get('year')
    $scope.termsUrl = websiteService.getTermsUrl()
    $scope.privacyUrl = websiteService.getPrivacyUrl()
  }
})()
